import { render, staticRenderFns } from "./AlertGeneralSettings.vue?vue&type=template&id=2b539812&scoped=true&lang=pug&"
import script from "./AlertGeneralSettings.vue?vue&type=script&lang=ts&"
export * from "./AlertGeneralSettings.vue?vue&type=script&lang=ts&"
import style0 from "./AlertGeneralSettings.vue?vue&type=style&index=0&id=2b539812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b539812",
  null
  
)

export default component.exports